





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CustomerModel } from '@/store/types/work/Providers';
import { CUSTOMERS_SHOW, OUTGOING_INVOICES_SHOW } from '@/router/work';

@Component
export default class CustomerItem extends Vue {
  @Prop() customer!: CustomerModel;

  get invoiceRoute () {
    if (this.customer.last_outgoing_invoice) {
      return { name: OUTGOING_INVOICES_SHOW, params: { invoice: this.customer.last_outgoing_invoice.id } };
    } else {
      return {};
    }
  }

  get customerRoute () {
    return { name: CUSTOMERS_SHOW, params: { customer: this.customer.id } };
  }
}
